"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotaType = void 0;
var QuotaType;
(function (QuotaType) {
    QuotaType["TEAM_MEMBERS"] = "TEAM_MEMBERS";
    QuotaType["PLANS"] = "PLANS";
    QuotaType["AI_REQUESTS"] = "AI_REQUESTS";
})(QuotaType || (exports.QuotaType = QuotaType = {}));
